/* Vintedoisk — nunca parar numa variação esgotada (26/10/2026). Carregado só no template de produto.
   Os tamanhos/cores esgotados não aparecem (product-variant-options.liquid), mas ao trocar a COR o tema mantinha o
   tamanho anterior: AZUL + P (que só existe em BEGE) → "ESGOTADO" com o botão travado, embora AZUL tivesse M.
   Agora, se a troca cai numa combinação esgotada, escolhe a 1ª disponível COM a opção que a cliente acabou de clicar
   e pede ao próprio tema para desenhar essa variação (sem recarregar a página). */
(function () {
  var ultimo = null;       // { posicao: 1|2|3, valor: 'AZUL' } — a opção que a cliente clicou por último
  var produto = null;      // /products/<handle>.js (variantes com options[] e available)
  var trocando = false;

  function carregarProduto(url) {
    if (produto) return Promise.resolve(produto);
    return fetch(url.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (p) { produto = p; return p; });
  }

  // a opção clicada: cada <fieldset> do seletor é uma opção (1º = posição 1…)
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.closest || !inp.closest('variant-selects')) return;
    var fs = inp.closest('fieldset');
    var lista = fs ? Array.prototype.slice.call(fs.parentElement.querySelectorAll(':scope > fieldset')) : [];
    var pos = lista.indexOf(fs) + 1;
    if (pos > 0) ultimo = { posicao: pos, valor: inp.value };
  }, true);

  function aoTrocar(ev) {
    var d = ev && ev.data;
    if (trocando) { trocando = false; return; }
    if (!d || !ultimo) return;
    if (d.variant && d.variant.available) return;
    var info = document.querySelector('product-info');
    if (!info) return;
    var url = info.dataset.url || location.pathname;
    carregarProduto(url).then(function (p) {
      if (!p || !p.available) return;
      var alvo = null;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v.available && v.options[ultimo.posicao - 1] === ultimo.valor) { alvo = v; break; }
      }
      if (!alvo || (d.variant && alvo.id === d.variant.id)) return;
      trocando = true;
      var pedido = url + '?section_id=' + encodeURIComponent(info.sectionId || info.dataset.section) + '&variant=' + alvo.id;
      if (typeof info.renderProductInfo === 'function' && typeof info.handleUpdateProductInfo === 'function' && (info.sectionId || info.dataset.section)) {
        info.includeVariantInUrl = true;
        info.renderProductInfo({ requestUrl: pedido, targetId: '', callback: info.handleUpdateProductInfo(url, document.body), isStickyChanged: true });
      } else {
        var u = new URL(location.href); u.searchParams.set('variant', alvo.id); location.replace(u.toString());
      }
    }).catch(function () { trocando = false; });
  }

  function iniciar() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, aoTrocar);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
